import React from 'react'
import { ConfigProvider } from 'antd'
import { Outlet } from 'react-router-dom'

const EmptyTemplate = () => {

  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            siderBg: '#F7F7F8!important'
          }
        }
      }}>
      <div className="overflow-x-hidden">
        <Outlet/>
      </div>
    </ConfigProvider>
  )
}

export default EmptyTemplate
